/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_All_PromptsInputs */

const en_gallery_all_prompts = /** @type {(inputs: Gallery_All_PromptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Prompts`)
};

const es_gallery_all_prompts = /** @type {(inputs: Gallery_All_PromptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los prompts`)
};

/**
* | output |
* | --- |
* | "All Prompts" |
*
* @param {Gallery_All_PromptsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_all_prompts = /** @type {((inputs?: Gallery_All_PromptsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_All_PromptsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_all_prompts(inputs)
	return es_gallery_all_prompts(inputs)
});